export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
export const SORT_NONE = false;
export const SORTS = [SORT_ASC, SORT_DESC, SORT_NONE];
